<div class="action-bar" #ActionBarContainer
     *ngIf="placeholder !== undefined"
     [style.top]="targetRegion.y + 'px'"
     [style.left]="targetRegion.x + 'px'"
     [style.width]="targetRegion.width + 'px'"
     [style.height]="targetRegion.height + 'px'"
     [style.transform]="'rotate(' + targetRegion.rotation + 'deg)'"
     [style.display]="display ? 'initial' : 'none'"
     [style.opacity]="triggersAreUseable ? '1.0' : '0.0'"
>
  <div class="trigger-group"
       #triggersRef
       [ngStyle] = "{
              'left': triggerGroup.left,
              'top': triggerGroup.top,
              'transform': 'translate('
                + triggerGroup.alignHorizontal
                + ', '
                + triggerGroup.alignVertical
                + ')'
              }"
  >
    <div class="trigger-inner-wrapper"
         [style.flexDirection]="triggerGroup.direction">
      <div *ngFor="let trigger of triggerGroup.triggers; trackBy: trackByLabel"
           class="trigger"
           (click)="triggerClicked(trigger.action)"
      >
        <div *ngIf="trigger.icon.type === 'font'">
          <mat-icon class="trigger-icon"
                    [style.transform]="'rotate(' + -targetRegion.rotation + 'deg)'"
          >{{trigger.icon.value}}</mat-icon>
        </div>
        <div *ngIf="trigger.icon.type === 'svg'">
          <mat-icon class="trigger-icon" [svgIcon]="trigger.icon.value"
                    [style.transform]="'rotate(' + -targetRegion.rotation + 'deg)'"
          ></mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/collage-designer/stage/placeholder/overlays/action-bar/action-bar.component.html